import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHero, SectionHeader, Reveal, CTABanner } from "@/components/ui-blocks";
import { SERVICES } from "@/data/site";

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHero
        eyebrow="Services"
        title={["Ten disciplines.", "One partner.", "Zero excuses."]}
        sub="Every service listed below is delivered in-house by senior PHOS teams — no shifting responsibility, no lost weeks between subs."
        image="https://images.pexels.com/photos/7108784/pexels-photo-7108784.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=940"
      />

      <section className="relative py-16 lg:py-24">
        <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
          <div className="border-t border-white/10">
            {SERVICES.map((svc) => (
              <Link
                key={svc.slug}
                to={`/services/${svc.slug}`}
                data-testid={`svc-list-${svc.slug}`}
                className="svc-card group relative flex flex-col md:flex-row md:items-center gap-6 py-10 border-b border-white/10 hover:bg-white/[0.02] transition-colors duration-500"
                onMouseMove={(e) => {
                  const r = e.currentTarget.getBoundingClientRect();
                  e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
                  e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
                }}
              >
                <div className="svc-glow" aria-hidden />
                <span className="font-display text-2xl text-accent leading-none md:w-32">{svc.number}</span>
                <div className="flex-1 flex flex-col md:flex-row md:items-center md:gap-10">
                  <h3 className="font-display text-3xl md:text-5xl lg:text-6xl uppercase tracking-tight leading-none flex-1 group-hover:translate-x-2 transition-transform duration-500">
                    {svc.title}
                  </h3>
                  <p className="text-ink-400 max-w-md text-sm leading-relaxed">{svc.short}</p>
                </div>
                <ArrowUpRight
                  size={26}
                  className="text-ink-600 group-hover:text-accent group-hover:-translate-y-1 group-hover:translate-x-1 transition-all duration-500"
                />
              </Link>
            ))}
          </div>
        </div>
      </section>

      <CTABanner
        eyebrow="Scope your project"
        heading={<>Not sure which{"\n"}service fits?</>}
        sub="Tell us the goal. We'll tell you the shortest path to get there — commercial, industrial, or otherwise."
        cta="Start the Conversation"
      />
    </div>
  );
}
